import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {state} from 'lit/decorators/state.js';
import {
	AttributeInterpreter,
	AttributeType,
	ChoiceValueDecisionState,
	ChoiceValueInterpreter,
	ConfigurationInterpreter, ConfiguratorErrorType, ExplainQuestionSubject, ExplainQuestionType
} from '@viamedici-spc/configurator-ts';

import {hoverInfo, widgetButton} from '../../css/styleSets';
import {SpcBaseValue} from './spcBaseValue';
import store from '../../store';
import {setExplainActive} from '../../slices/statusSlice';

@customElement('spc-choice-value')
export class SpcChoiceValue extends SpcBaseValue {

	@state()
	selectedChoiceValueIds = [];

	static styles = [
		widgetButton,
		hoverInfo,
		css`
			:host {
				flex-grow: 1;
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
				max-width: 100%;
				flex-grow: 1;
			}

			.hidden {
				display: none;
			}
			.listSelect button {
				text-align: left;
			}
		`];

	stateChanged(s) {
		super.stateChanged(s);
		// this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeId);
		this.isMultiselect = AttributeInterpreter.isChoiceAttributeMultiSelect(this.attribute);
		this.selectedChoiceValueIds = AttributeInterpreter.getIncludedChoiceValues(this.attribute).map((a) => a.id);
		this.selectedChoiceValueId = this.selectedChoiceValueIds[0] ?? null;
		// console.log('SpcChoiceValue', this.attribute, this.selectedChoiceValueIds, this.selectedChoiceValueId);
	}

	makeDecision() {
		this.session.makeDecision({
			type: AttributeType.Choice,
			attributeId: this.attribute.id,
			choiceValueId: this.value.id,
			state: ChoiceValueDecisionState.Included
		})
			.catch(e => {
				if (e.type === ConfiguratorErrorType.ConflictWithConsequence) {
					this.session.explain({
						subject: ExplainQuestionSubject.choiceValue,
						question: ExplainQuestionType.whyIsStateNotPossible,
						choiceValueId: e.choiceValueId,
						state: ChoiceValueDecisionState.Included,
						attributeId: e.globalAttributeId
					}, 'full')
						.then(
							explainAnswer => {
								let cause = null;
								let solution = null;
								if (explainAnswer.decisionExplanations.length > 0) {
									cause = explainAnswer.decisionExplanations[0].causedByDecisions.map(cbd => (
										{
											attributeLocalId: cbd.attributeId,
											valueId: cbd.choiceValueId
										}
									));
									solution = explainAnswer.decisionExplanations[0].solution;
								}
								store.dispatch(setExplainActive(
									{
										explainActive: true,
										desire: {
											attributeId: this.attribute.id,
											valueId: this.value.id
										},
										cause: cause,
										solution: solution
									}
								));
							}
						);
				}
			});
	}

	isIncluded() {
		console.log('SpcChoiceValue isIncluded', this.value.id, this.selectedChoiceValueIds);
		return this.selectedChoiceValueIds.includes(this.value.id);
	}

	canBeIncluded() {
		return this.value.possibleDecisionStates.includes(ChoiceValueDecisionState.Included);
	}

	canBeExcluded() {
		return this.value.possibleDecisionStates.includes(ChoiceValueDecisionState.Excluded);
	}
	isAllowed() {
		return ChoiceValueInterpreter.isAllowed(this.value);
	}

	render() {
		if (!this.value) return null;
		return html`
			<div class="item ${classMap({
				selected: this.isIncluded(),
				disabled: !this.isAllowed(),
				implicit: this.isImplicit(),
				fixed: !this.canBeExcluded(),
				hidden: !this.isVisible(),
				listSelect: this.displayStyle === 'listSelect'
			})}">
				<button @click="${this.makeDecision}">
					<trans-label key="${this.attribute.key}" value="${this.value.id}" context="FV" showIdWhenMissing="${true}"></trans-label>
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">${this.getInfoText()}</div>
					</div>
				`)}

			</div>
		`;
	}
}
